import React from "react";
import { PRESETS, presetFor } from "@/lib/scenarios";

export default function ScenarioPresets({ current, onPick }) {
  const match = presetFor(current);
  return (
    <div data-testid="scenario-presets">
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-neutral-500">Try a scenario</p>
      <div className="flex flex-wrap gap-2">
        {PRESETS.map((p) => {
          const active = match?.key === p.key;
          return (
            <button key={p.key} data-testid={`preset-${p.key}`} onClick={() => onPick(p)}
              className={`rounded-full border px-4 py-2 text-sm font-medium transition-colors ${active ? "border-transparent text-white" : "border-neutral-200 text-neutral-700 hover:bg-neutral-50"}`}
              style={active ? { backgroundColor: "var(--tenant-primary)" } : undefined}>
              {p.name} <span className={active ? "text-white/80" : "text-neutral-400"}>+{p.rev_up} / −{p.cogs_down} / −{p.ovh_down}</span>
            </button>
          );
        })}
        {!match && (
          <span data-testid="preset-custom" className="rounded-full px-4 py-2 text-sm font-medium text-white" style={{ backgroundColor: "var(--tenant-primary)" }}>
            Custom <span className="text-white/80">+{current.rev_up} / −{current.cogs_down} / −{current.ovh_down}</span>
          </span>
        )}
      </div>
      {match?.key === "stretch" && (
        <p className="mt-2 text-xs italic text-neutral-500" data-testid="stretch-note">A stretch goal takes a plan, some elbow grease, and time.</p>
      )}
    </div>
  );
}
